export interface AppealBody {
  surveyRequestId?: string;
  appealReason?: AppealReason;
  appealComment?: string;
  sectionValue?: string;
  completedDate?: string;
  brandId?: string;
  dealerId?: string;
  region?: string;
  appealID?: string;
  appealId?: string;
  attachments?: any
}

export type ApplicationMainAreaType = "Sales" | "Aftersales" | undefined;

export type AppealStatus =
  | "appealable"
  | "marketRejected"
  | "marketApproved"
  | "marketPending"
  | "regionRejected"
  | "regionApproved"
  | "regionPending"
  | "expired";

export const appealReason = [
  { id: 1, name: "appealFirstReason" },
  { id: 2, name: "appealSecondReason" },
  { id: 3, name: "appealThirdReason" },
  { id: 4, name: "appealFourthReason" },
  { id: 5, name: "appealFifthReason" },
  { id: 6, name: "appealSixthReason" },
];

export type AppealReason =
  | 1 //customer referring to different dealer
  | 2 //customer referring to a different repairer
  | 3 //low scores but positive verbatim
  | 4 //customer referring to a different vehicle
  | 5 //difference in q1 and q2 scores > 7
  | 6; //other

export class Appeal {
  action: string = "";
  appealId: string = "";
  appealID: string = "";
  appealDateTime: Date | string = "";
  appealReason!: AppealReason;
  appealReasonDesc: string = "";
  appealComment: string = "";
  marketStatus: string = "";
  marketComment: string = "";
  marketResponseDateTime: Date | string = "";
  regionStatus: string = "";
  regionComment: string = "";
  regionResponseDateTime: Date | string = "";
  sectionValue: ApplicationMainAreaType;
  brandId: string = "";
  regionId: string = "";
  marketId: string = "";
  dealerId: string = "";
  dealerName: string = "";
  outletId: string = "";
  outletName: string = "";
  dtInsert: number = 0;
  usrInsert: string = "";
  dtCancel: number = 0;
  usrCancel: string = "";
  surveyRequestId: string = "";
  createdOn: number = 0;
  dtClose: number = 0;
  usrClose: string = "";
  wave: string = "";
  vin: string = "";
  customerName: string = "";
  completedDate: Date | string = "";
  user: string = "";
  firstName: string = "";
  lastName: string = "";
  overallSatisfaction: string = "";
  recommendationScore: string = "";
  model: string = "";
  agentName: string = "";
  status: AppealStatus;
  approveAppeal: string = "";
  rejectAppeal: string = "";
  disabled: boolean;
  success: boolean | undefined;
  overallLikesVerbatim: string = "";
  overallDislikesVerbatim: string = "";
  executedDateProcess: Date | string = "";
  dtInterviewRemoveDate: Date | string = "";

  constructor(response?: any) {
    if (response) {
      Object.assign(this, response);
      this.appealReason = response.appealReason;
    }
    this.appealDateTime = this.parseDate(this.appealDateTime);
    this.executedDateProcess = this.parseDate(this.executedDateProcess);
    this.dtInterviewRemoveDate = this.parseDate(this.dtInterviewRemoveDate);
    this.marketResponseDateTime = this.parseDate(this.marketResponseDateTime);
    this.regionResponseDateTime = this.parseDate(this.regionResponseDateTime);
    this.completedDate = this.parseDate(this.completedDate);
    let reason = appealReason.find((el) => el.id === this.appealReason);
    this.appealReasonDesc = reason ? reason.name : "";
    this.marketStatus = this.marketStatus ? this.marketStatus.replace("market", "") : "";
    this.regionStatus = this.regionStatus ? this.regionStatus.replace("region", "") : "";
    if (this.marketStatus === "Pending") {
      this.status = "marketPending";
    } else if (this.regionStatus === "Pending") {
      this.status = "regionPending";
    } else {
      this.status = "expired";
    }
    this.disabled = false;
  }
  private parseDate(date: any) {
    // if (date) {
    //     let parsedDate: string
    //     try {
    //         parsedDate = moment(date).format('DD/MM/YYYY')
    //     } catch(e) {
    //         parsedDate = ''
    //     }
    //     return parsedDate
    // } else {
    //     return ''
    // }
    let dateObject;
    if (date) {
      dateObject = new Date(date);
    } else {
      dateObject = "";
    }
    return dateObject;
  }
}
